import { useEffect, useState } from "react";
import { Timer, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const explain = (say) => {
  const parts = say.split(/Pick an answer\.|एक जवाब चुनिए।/);
  if (parts.length > 1) return parts.pop().trim();
  const q = say.search(/[?]/);
  return q >= 0 ? say.slice(q + 1).trim() : say;
};

export const Check = ({ s, picked, onPick, onNext }) => {
  const { L } = useLang();
  const tone = (i) => {
    if (picked == null) return "border-slate-200 bg-white hover:border-[#14B8A6] hover:bg-[#F0FDFA]";
    if (i === s.answer) return "border-[#059669] bg-[#ECFDF5] text-[#065F46]";
    return i === picked ? "border-[#DC2626] bg-[#FEF2F2] text-[#991B1B]" : "border-slate-200 bg-white opacity-60";
  };
  return (
    <div className="mt-5" data-testid="lecture-check">
      <div className="grid gap-2">
        {s.options.map((o, i) => (
          <button key={i} type="button" disabled={picked != null} onClick={() => onPick(i)} className={`text-left rounded-xl border-2 px-4 py-3 text-sm font-semibold transition-colors ${tone(i)}`} data-testid={`lecture-check-option-${i}`}>
            <span className="mr-2 text-slate-400">{String.fromCharCode(65 + i)}.</span>{o}
          </button>
        ))}
      </div>
      {picked != null && (
        <div className="mt-4 rounded-xl bg-white border border-slate-200 p-3" data-testid="lecture-check-feedback">
          <div className={`text-sm font-black ${picked === s.answer ? "text-[#059669]" : "text-[#DC2626]"}`}>{picked === s.answer ? L("Correct, well done!", "सही जवाब, शाबाश!") : L("Not quite. The right answer is in green.", "सही नहीं। सही जवाब हरे रंग में है।")}</div>
          <p className="mt-1 text-xs text-slate-600 leading-relaxed">{explain(s.say)}</p>
          <button type="button" onClick={onNext} className="mt-3 inline-flex items-center gap-1.5 text-sm font-bold text-[#0F766E]" data-testid="lecture-check-continue">{L("Continue", "आगे बढ़ें")}<ArrowRight className="w-4 h-4" /></button>
        </div>
      )}
    </div>
  );
};

const mmss = (n) => `${Math.floor(n / 60)}:${String(n % 60).padStart(2, "0")}`;

export const Activity = ({ s, onNext }) => {
  const { L } = useLang();
  const [left, setLeft] = useState(null);
  useEffect(() => {
    if (!left) return undefined;
    const id = setTimeout(() => setLeft(left - 1), 1000);
    return () => clearTimeout(id);
  }, [left]);
  return (
    <div className="mt-5" data-testid="lecture-activity">
      <ol className="space-y-2">
        {[...s.prompt, ...s.bullets].map((p, i) => <li key={i} className="flex gap-3 text-[15px] text-slate-700"><span className="shrink-0 w-6 h-6 rounded-full bg-[#0B1F3A] text-white text-xs font-bold grid place-items-center">{i + 1}</span>{p}</li>)}
      </ol>
      <div className="mt-5 flex flex-wrap items-center gap-3">
        <span className="inline-flex items-center gap-2 rounded-full bg-[#FFF7ED] border border-[#FED7AA] px-4 h-10 text-sm font-black text-[#B45309]" data-testid="lecture-activity-timer"><Timer className="w-4 h-4" />{mmss(left ?? s.minutes * 60)}</span>
        {left == null && <button type="button" onClick={() => setLeft(s.minutes * 60)} className="rounded-full bg-[#B45309] text-white px-4 h-10 text-sm font-bold" data-testid="lecture-activity-start">{L(`Start ${s.minutes}-minute timer`, `${s.minutes} मिनट का टाइमर शुरू करें`)}</button>}
        <button type="button" onClick={onNext} className="rounded-full border border-slate-300 bg-white px-4 h-10 text-sm font-bold text-[#0B1F3A]" data-testid="lecture-activity-done">{left === 0 ? L("Time up, continue", "समय पूरा, आगे बढ़ें") : L("I am done, continue", "हो गया, आगे बढ़ें")}</button>
      </div>
    </div>
  );
};
